import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties"; //@ts-check

import React from 'react';
import FrameToolbar from '../../../../frame/FrameToolbar';
/**
 * @param {import('./types').RunToolbarProps} props
 * @returns {import('frame/FrameToolbar/types').FrameToolbarProps}
 */

var getToolbarProps = function getToolbarProps(props) {
  var toolbarProps = props.toolbarProps,
      state = _objectWithoutProperties(props, ["toolbarProps"]);

  var onSave = state.onSave,
      onSubmit = state.onSubmit;
  var title = state.title,
      running = state.running,
      submitting = state.submitting,
      submitted = state.submitted,
      saving = state.saving,
      dirty = state.dirty;
  var jobId = state.jobId,
      onEvent = state.onEvent;
  /** @type {import('core/Icon/types').IconProps} */

  var saveIcon = {
    type: saving ? 'loading' : 'save',
    label: saving ? 'Saving' : 'Save',
    hoverable: true,
    onClick: onSave,
    disabled: running || submitting || submitted || saving || !dirty && !!jobId
  };
  /**@type {import('core/Button/types').ButtonProps} */

  var submitButton = {
    children: submitting ? 'Finalizing...' : 'Finalize',
    disabled: running || submitting || submitted || saving,
    onClick: onSubmit
  };
  var crtToolbarProps = {
    title: title,
    icons: [saveIcon],
    button: submitButton
  };
  if (typeof toolbarProps === 'undefined') return crtToolbarProps;

  if (typeof toolbarProps === 'object') {
    if (toolbarProps.title) crtToolbarProps.title = toolbarProps.title;
    if (toolbarProps.moreOptions) crtToolbarProps.moreOptions = toolbarProps.moreOptions;
    if (toolbarProps.icons) throw new Error('toolbarProps.icons not implemented');

    if (toolbarProps.button) {
      crtToolbarProps.button = _objectSpread({}, crtToolbarProps.button, toolbarProps.button);

      if (toolbarProps.button.onClick) {
        //custom submit onClick action
        crtToolbarProps.button.onClick = function (e) {
          onEvent('Submit');
          var returnedValue = toolbarProps.button.onClick(e);

          if (returnedValue && returnedValue.then) {
            return returnedValue.then(function () {
              onEvent('Submit.Resolved');
            }).catch(function () {
              onEvent('Submit.Rejected');
            });
          }
        };
      }
    }

    return crtToolbarProps;
  }
};
/**
 * @param {import('./types').RunToolbarProps} props
 */


var Toolbar = function Toolbar(props) {
  return React.createElement(FrameToolbar, getToolbarProps(props));
};

export default React.memo(Toolbar);